var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('shipment-payment-error-view',{staticClass:"shipment-payment-dialog-payment-error-view",on:{"retry":function($event){return _vm.$emit('retry')},"close":function($event){return _vm.$emit('close')}}})}
var staticRenderFns = []

export { render, staticRenderFns }